import {useDispatch, useSelector} from "react-redux";
import { useT } from '../../../../../../helpers/i18n';
import {useEffect, useRef, useState} from "react";
import * as React from "react";
import {
    fetchPropertyBedrooms,
    fetchPropertyPool,
    fetchPropertySpace,
    fetchPropertySpaces
} from "../../../../../../redux/actions";
import {useInViewport} from "react-in-viewport";
import Skeleton from "react-loading-skeleton";
import FiltersModal from "../../../../properties/partials/FiltersModal";
import RightModal from "../../../../properties/partials/RightModal";
import Button from "@mui/material/Button";
import SwipperWrapper from "../../../../properties/partials/SwipperWrapper";
import SimpleContent from "../../../../properties/partials/SImpleContent";
import FeaturesList from "../../../../properties/partials/FeaturesList";
import AttributesList from "../../../../properties/partials/AttributesList";
import BedroomsModal from "../../../../index/sections/BedroomsModal";
import ContentWrapper from "../../../../properties/partials/ContentWrapper";
import Checkers from "../../../../../../helpers/class/Checkers";

const MAX_VISIBLE_FACILITIES = 4;

function facilitiesSummary ( facilities ) {
    if ( !Checkers.isValidArray( facilities ) ) {
        return null;
    }
    const visible = facilities.slice( 0, MAX_VISIBLE_FACILITIES );
    const rest = facilities.length - visible.length;
    return visible.join( ' · ' ) + ( rest > 0 ? ' · +' + rest + ' more' : '' );
}

function widthClassesForCount ( count ) {
    if ( count === 1 ) {
        const cls = 'col-md-12 col-sm-12 col-xs-12';
        return { master: cls, prePrePreLast: cls, prePreLast: cls, preLast: cls, last: cls };
    }
    if ( count % 3 === 0 ) {
        const cls = 'col-md-4 col-sm-4 col-xs-12';
        return { master: cls, prePrePreLast: cls, prePreLast: cls, preLast: cls, last: cls };
    }
    if ( count % 2 === 0 ) {
        const cls = 'col-md-6 col-sm-6 col-xs-12';
        return { master: cls, prePrePreLast: cls, prePreLast: cls, preLast: cls, last: cls };
    }
    if ( ( count + 1 ) % 3 === 0 ) { // 5, 8, 11, 14
        return {
            master: 'col-md-6 col-sm-6 col-xs-12',
            prePrePreLast: 'col-md-6 col-sm-6 col-xs-12',
            prePreLast: 'col-md-4 col-sm-4 col-xs-12',
            preLast: 'col-md-4 col-sm-4 col-xs-12',
            last: 'col-md-4 col-sm-4 col-xs-12'
        };
    }
    if ( ( count + 2 ) % 3 === 0 ) { // 4, 7, 10, 13, 16
        return {
            master: 'col-md-4 col-sm-4 col-xs-12',
            prePrePreLast: 'col-md-3 col-sm-6 col-xs-12',
            prePreLast: 'col-md-3 col-sm-6 col-xs-12',
            preLast: 'col-md-3 col-sm-6 col-xs-12',
            last: 'col-md-3 col-sm-6 col-xs-12'
        };
    }
    const cls = 'col-md-4 col-sm-4 col-xs-12';
    return { master: cls, prePrePreLast: cls, prePreLast: cls, preLast: cls, last: cls };
}

function widthClassForIndex ( index, count, classes ) {
    const revindex = count - index;
    if ( revindex === 1 ) return classes.last;
    if ( revindex === 2 ) return classes.preLast;
    if ( revindex === 3 ) return classes.prePreLast;
    if ( revindex === 4 ) return classes.prePrePreLast;
    return classes.master;
}

export default function ExtendedSpaces ( props ){
  const t = useT();

    const config = {disconnectOnLeave: false};

    const options = {};

    const myRef = useRef();

    const {
        inViewport
    } = useInViewport(
        myRef,
        options,
        config,
        props
    );

    const dispatch = useDispatch()

    const propertyId = useSelector( state => state['propertiesParams']['property_id']);

    const [ areasLoaded, setAreasLoaded ] = useState( false );
    const [ bedroomsLoaded, setBedroomsLoaded ] = useState( false );

    useEffect( () => {
        let cancelled = false;
        setAreasLoaded( false );
        Promise.resolve( dispatch<any>( fetchPropertySpaces(propertyId) ) )
            .catch( () => undefined )
            .then( () => { if ( !cancelled ) setAreasLoaded( true ); } );
        return () => { cancelled = true; };
    }, [inViewport, propertyId])

    const componentLoading = useSelector( state => state['singlePropertyData']['loading'])

    const propertyPools = useSelector( state => state['singlePropertyData']['pools'])

    const propertySpaces = useSelector( state => state['singlePropertyData']['spaces'])


    const [ modalState, setModalState ] = useState( "close" );

    const modalData = useSelector( state => state['singlePropertyData']['modal'])

    const modalMedia = useSelector( state => state['singlePropertyData']['modal']['valid'] ? state['singlePropertyData']['modal']['data']['media'] : null )

    const modalDataExtendend = useSelector( state => state['singlePropertyData']['modal']['valid'] ? state['singlePropertyData']['modal']['data'] : null )

    const modalContent = useSelector( state => state['singlePropertyData']['modal']['valid'] ? state['singlePropertyData']['modal']['data']['description'] : null )

    const modalContentExtra = useSelector( state => state['singlePropertyData']['modal']['valid'] ? state['singlePropertyData']['modal']['data']['space_details'] : '' )

    const modalFeaturesList = useSelector( state => state['singlePropertyData']['modal']['valid'] ? state['singlePropertyData']['modal']['data']['features'] : null )

    const pageId = useSelector(state => state['propertiesParams']['page_id']);

    const [propertyBedrooms, setPropertyBedrooms] = useState(null);
    const bedroomsRequestIdRef = useRef(0);

    const isHotel = useSelector(state => state['appSettings']['isHotel'])

    const handleShow = ( type, area_id ) => {
        if (type=='poolModal' ) {
            dispatch<any>(fetchPropertyPool(pageId, propertyId, area_id))
        } else if ( type=='spaceModal' ) {
            dispatch<any>(fetchPropertySpace(pageId, propertyId, area_id))
        } else if ( type=='bedroomsModal' ) {
            // dispatch<any>(fetchPropertyBedrooms(pageId, propertyId))
        }

        setModalState( type+(area_id!=null ? area_id : '') );
    }

    const handleHide = () => {
        setModalState( "close" );
    }

      useEffect(() => {
        const requestId = ++bedroomsRequestIdRef.current
        setBedroomsLoaded(false)

        Promise.resolve(dispatch<any>(fetchPropertyBedrooms(pageId, propertyId))).then((bedroomsData : any) => {
          if (requestId !== bedroomsRequestIdRef.current) return
          setPropertyBedrooms(bedroomsData)
          setBedroomsLoaded(true)
        }).catch(() => {
          if (requestId === bedroomsRequestIdRef.current) setBedroomsLoaded(true)
        })
      }, [pageId, propertyId])

    const validPools = Checkers.isValidArray(propertyPools) ? propertyPools.filter((pool) => pool.media != null) : [];
    const firstBedroomWithImage = !isHotel && Checkers.isValidArray(propertyBedrooms)
        ? propertyBedrooms.find((bedroom) => Checkers.isValidArray(bedroom.media))
        : null;
    const validSpaces = Checkers.isValidArray(propertySpaces) ? propertySpaces.filter((space) => space.media != null) : [];

    const tiles = [
        ...validPools.map((pool) => ({
            key: 'pool' + pool.pool_id,
            title: pool.pool_title,
            imageSquare: pool.media.image_square_thumb,
            onClick: () => handleShow('poolModal', pool.pool_id),
            modal: (
                <RightModal
                    key={100}
                    modalName={'poolModal'+pool.pool_id}
                    className="slide_right"
                    Title={pool.pool_title}
                    modalSize="lg"
                    loaderStatus={!modalData.valid}
                    closeModal={() => { handleHide() }}
                    show={modalState === 'poolModal'+pool.pool_id}
                    BodyRender={ <ContentWrapper ContentRender={
                        <>
                            <SwipperWrapper key="pool-images-swiper"  images={modalMedia} enableFancyBox={true} enableAlbumRightModal={false} />
                            <SimpleContent content={modalContent} />
                            <AttributesList data={modalDataExtendend}/>
                            <FeaturesList featureList={modalFeaturesList}/>
                        </>
                    } /> }
                />
            )
        })),
        ...(firstBedroomWithImage != null ? [{
            key: 'bedrooms',
            title: t('property.bedrooms'),
            imageSquare: firstBedroomWithImage.media[0].image_square_thumb,
            onClick: () => handleShow('bedroomsModal', null),
            modal: (
                <BedroomsModal
                    key={100}
                    bedrooms={propertyBedrooms}
                    pageId={pageId}
                    propertyId={propertyId}
                    show={modalState === 'bedroomsModal'}
                    onClose={() => { handleHide() }}
                />
            )
        }] : []),
        ...validSpaces.map((space) => ({
            key: 'space' + space.space_id,
            title: space.space_title,
            subtitle: facilitiesSummary(space.facilities),
            imageSquare: space.media.image_square_thumb,
            onClick: () => handleShow('spaceModal', space.space_id),
            modal: (
                <RightModal
                    key={100}
                    modalName={'spaceModal'+space.space_id}
                    className="slide_right"
                    Title={space.space_title}
                    modalSize="lg"
                    loaderStatus={!modalData.valid}
                    closeModal={() => { handleHide() }}
                    show={modalState === 'spaceModal'+space.space_id}
                    BodyRender={ <ContentWrapper ContentRender={
                        <>
                            <SwipperWrapper key="space-images-swiper" images={modalMedia} enableFancyBox={true} enableAlbumRightModal={false} />
                            <SimpleContent content={modalContent} extraContent={modalContentExtra}/>
                            <AttributesList data={modalDataExtendend}/>
                            <FeaturesList featureList={modalFeaturesList}/>
                        </>
                    } /> }
                />
            )
        }))
    ];

    const widthClasses = widthClassesForCount(tiles.length);

    return (
        ( componentLoading || !areasLoaded || !bedroomsLoaded ) ?
            <>
                <div ref={myRef}>
                    <Skeleton height={30} className="col-8 col-sm-5 col-md-3 b-rad-md mb-1"/>
                    <Skeleton height={42} className="col-8 col-sm-6 col-md-4 b-rad-md mb-2"/>
                    <Skeleton height={70} className="col-12 col-sm-10 col-md-8 b-rad-md mb-1"/>
                    <Skeleton height={150} className="col-12 b-rad-lg"/>
                </div>
            </>
            :
            <>
                {
                    !props.isHotel && tiles.length > 0 &&
                        <div className="col-12">
                            <p className="block-title m-t-40 hint-text no-margin">{t('property.spaces')}</p>
                            <h2 className="m-t-5">{t('property.layout')}</h2>
                            <div id="pro_detail_spaces" className="p-b-65">
                                <div className="container">
                                    <div className="row">
                                        {
                                            tiles.map((tile, index) => {
                                                const widthClass = widthClassForIndex(index, tiles.length, widthClasses);

                                                return (
                                                    <React.Fragment key={tile.key}>
                                                        <div
                                                            className={widthClass + ' text-center bg-success hover-push demo-story-block'}
                                                            onClick={tile.onClick}
                                                        >
                                                            <div className="hover-backdrop" style={{ backgroundImage: 'url(' + tile.imageSquare + ')' }}/>
                                                            <div className="hover-caption bottom-left bottom-right p-b-20">
                                                                <h4 className="fs-16 text-white m-b-0">{tile.title}</h4>
                                                            </div>
                                                        </div>
                                                        {tile.modal}
                                                    </React.Fragment>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </>
    )
}